import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, linkedSignal } from "@angular/core";

import { ServiceType as GqlServiceType } from "../../../apis/networkdashboard/graphql/graphql";
import { ServiceType } from "../../../pages/subscription-detail/types";
import { PortVisualiser } from "../port-visualiser/port-visualiser";
import { ServiceSummary } from "../service-summary/service-summary";
import { ServiceRowComponent } from "./components/service-row/service-row";

interface PortServicesSubscription {
  services?: ServiceType[] | null;
  tags: string[];
}

@Component({
  selector: "port-services-panel",
  templateUrl: "port-services-panel.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, PortVisualiser, ServiceRowComponent, ServiceSummary, TranslatePipe],
})
export class PortServicesPanel {
  protected subscription = input.required<PortServicesSubscription>();
  protected services = computed(() => this.subscription().services ?? []);

  protected activeSubscription = linkedSignal<ServiceType[], ServiceType | undefined>({
    source: () => this.services(),
    computation: (services, previous) => (services.length > 0 && !previous?.value ? services[0] : previous?.value),
  });

  protected activeSubscriptionVlanranges = computed(() => [this.activeSubscription()?.vlanrange ?? ""]);
  protected tags = computed(() => this.subscription().tags);
  protected activeSubscriptionId = computed(() => this.activeSubscription()?.subscriptionId);

  protected setActiveSubscription(subscription: ServiceType | undefined) {
    this.activeSubscription.set(subscription);
  }

  protected onClickBar(service: GqlServiceType) {
    this.setActiveSubscription(this.services().find((x) => x.subscriptionId === service.subscriptionId));
  }
}
